import { MouseEvent } from 'react';

export const isKeyboardModifierClick = (e: MouseEvent): boolean => {
  return e && (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey);
};
